<template>
  <div>
    <b-button-group class="m-3">
      <b-button variant="secondary" to="/admin">文章列表</b-button>
      <b-button variant="primary" to="/admin/add">新增文章</b-button>
    </b-button-group>
    <router-view></router-view>
  </div>
</template>

<script>
export default {}
</script>